<template>
	<div class="relation " :class="{ container: !content.fullWidth }">
		<div class="relation__items" :style="cssVars">
			<Card
				v-for="(relation, index) in contentComp"
				:key="index + 'relation'"
				:item="relation"
				:cover-height="coverHeight"
				responsive-cover-height="230px"
				class="relation__item"
			>
				<component
					:is="titleComponent"
					v-if="$path(relation, 'title')"
					class="'relation__title"
					:class="'relation__title--' + content.titlePlacement"
				>
					{{ relation.title }}
				</component>
			</Card>
		</div>
	</div>
</template>

<script>
import Card from '@/components/Card'

export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		contentComp() {
			return this.content.relations.map(element => {
				return {
					title: element.title,
					focalPoint: element.thumbnail.focalPoint,
					url: element.thumbnail.url,
					slug: element.slug,
				}
			})
		},
		titleComponent() {
			if (this.content.titlePlacement !== 'overlay') return 'div'
			return 'h2'
		},
		cssVars() {
			return {
				'--content-gap': this.getGap(this.content.gap),
				'--items-count': this.content.itemsCount,
			}
		},
		coverHeight() {
			switch (this.content.coverHeight) {
				case 'small':
					return '342px'
				case 'medium':
					return '380px'
				case 'large':
					return '420px'
				default:
					return '300px'
			}
		},
	},
	methods: {
		getGap(size) {
			switch (size) {
				case 'small':
					return '0.5rem'
				case 'medium':
					return '5rem'
				case 'large':
					return '8rem'
				default:
					return '0.5rem'
			}
		},
	},
	components: {
		Card,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.relation {
	&__items {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		display: grid;
		grid-gap: 2rem var(--content-gap);
		grid-template-columns: repeat(var(--items-count), 1fr);

		@include respond-below('phone') {
			grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		}
		.card__cover {
			@include respond-below('desktop') {
				img {
					height: 230px !important;
				}
			}
		}
	}
	&__item {
		position: relative;
		color: white;
	}

	&__title {
		@include respond-below('phone') {
			font-size: 16px;
		}
		&--overlay {
			text-align: center;
			margin: 0;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		&--under {
			margin-top: 1rem;
			text-transform: uppercase;
			font-weight: 400;
			text-decoration: none;
			@include respond-below('phone') {
				margin-top: 0.5rem;
			}
		}
	}
}
</style>
